import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '1 — ¿Cómo recibo el Kit después de comprar?',
    a: 'Inmediatamente después del pago recibes un correo con el enlace de descarga. El acceso es en menos de 5 minutos. Sin esperas ni trámites.'
  }, {
    q: '2 — ¿Sirve para mi país?',
    a: 'Sí. El Kit usa principios financieros universales sin citar leyes ni sistemas específicos de un solo país. Cualquier docente de habla hispana puede aplicarlo sin modificaciones.'
  }, {
    q: '3 — ¿Está actualizado a 2025/2026?',
    a: 'Sí. Incluye criptomonedas, fintechs, estafas digitales y seguridad en apps financieras. El material refleja la realidad que viven tus alumnos hoy.'
  }, {
    q: '4 — ¿Qué diferencia tiene con buscar en Google?',
    a: 'Google te da información suelta. El Kit te da un sistema completo: secuencias didácticas, actividades listas, evaluaciones con rúbrica y planificación anual. La diferencia entre tener ingredientes sueltos y tener el plato servido.'
  }, {
    q: '5 — ¿Necesito algún programa especial?',
    a: 'No. Son PDFs de alta resolución que se abren en cualquier dispositivo. Las plantillas vienen también en Word y Excel editables.'
  }, {
    q: '6 — ¿Sirve para alumnos que dicen que las finanzas no son lo suyo?',
    a: 'Especialmente para ellos. El Kit conecta cada concepto con situaciones concretas de la vida adolescente: tarjetas, suscripciones, apuestas, cripto, primer trabajo. Los alumnos pasan del "esto no es para mí" al "¿por qué nadie me enseñó esto antes?".'
  }, {
    q: '7 — ¿Cómo me protege contra las tareas hechas con ChatGPT?',
    a: 'Las actividades del Tomo 1 (autoconocimiento financiero) y los desafíos prácticos (simulador del gasto hormiga, torneo de inversión, validación de ideas) requieren reflexión personal y decisiones reales. Una IA no puede vivir la economía de tu alumno por él.'
  }, {
    q: '8 — ¿Es editable o solo PDF?',
    a: 'Recibes ambos formatos. PDF para proyectar o imprimir. Word y Excel editables para adaptar consignas, sumar tu nombre, tu institución o cualquier modificación. Es tuyo para usarlo como quieras.'
  }, {
    q: '9 — ¿En qué moneda pago?',
    a: 'El precio está en dólares estadounidenses (USD 19,90). El cobro se procesa automáticamente en la moneda de tu país: pesos argentinos, mexicanos, colombianos, soles peruanos, pesos chilenos o cualquier otra moneda local según corresponda. No necesitas tener dólares.'
  }, {
    q: '10 — ¿Qué pasa si no me gusta?',
    a: 'Tienes 7 días de garantía total. Si por cualquier motivo el Kit no cumple tus expectativas, te devolvemos el 100%. Sin preguntas, sin formularios, sin esperas. Una persona real te responde y resolvemos.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt border-b border-brand-accent/10" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <h2 className="text-xl md:text-2xl font-black text-center mb-6 text-white uppercase tracking-tight" data-id="element-79">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3" data-id="element-80">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-card rounded-lg border-2 ${openIndex === index ? 'border-brand-accent' : 'border-white/5'} overflow-hidden transition-all duration-200 shadow-lg`} data-id="element-81">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-82">
                <span className={`font-black text-sm md:text-base pr-4 ${openIndex === index ? 'text-brand-accent' : 'text-gray-200'}`} data-id="element-83">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0" data-id="element-84" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0" data-id="element-85" />}
              </button>

              <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-86">
                <p className="text-sm md:text-base text-gray-300 leading-relaxed pt-3 border-t border-white/10 font-bold" data-id="element-87">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}